const getImpuestoArticuloTipo = (
  articulo: $TSMigrationFixMe,
  taxes = [],
  isLibrado: $TSMigrationFixMe
) => {
  const impuestoCuentaContableId =
    articulo[`cuentaContableRepercutido${isLibrado ? "Librado" : "Librador"}Id`]
  const taxe = taxes.find(
    ({ grupoImpuesto, valor, cuentaContableEmpresa }) =>
      // @ts-expect-error TS(2339): Property 'categoria' does not exist on type 'never...
      grupoImpuesto.categoria === articulo.impuestoRepercutido &&
      valor === articulo.tarifaImpuesto &&
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      cuentaContableEmpresa.id === impuestoCuentaContableId
  )

  if (!taxe) {
    const taxe = taxes.find(
      ({ porDefecto, valor }) =>
        porDefecto === true && valor === articulo.tarifaImpuesto
    )
    return {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      impuestoArticuloTipoId: taxe?.id,
      // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
      impuestoArticuloPorcentaje: taxe?.valor,
    }
  }
  return {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    impuestoArticuloTipoId: taxe?.id,
    // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
    impuestoArticuloPorcentaje: taxe?.valor,
  }
}

const mapArticulosFromDocumento = (
  articulos = [],
  tiposImpuestosArticulos: $TSMigrationFixMe,
  isLibrado: $TSMigrationFixMe
) => {
  return articulos.map((articulo) => ({
    // @ts-expect-error TS(2339): Property 'articulo' does not exist on type 'never'...
    ...articulo.articulo,
    ...getImpuestoArticuloTipo(articulo, tiposImpuestosArticulos, isLibrado),
    // @ts-expect-error TS(2339): Property 'cantidad' does not exist on type 'never'...
    cantidad: articulo.cantidad,
  }))
}

export default mapArticulosFromDocumento
